<template>
    <div>
      <div v-if="loading" class="loader"></div>
      <h3 align="center" v-if="loading" >Loading Data...</h3>
      <div v-if="!loading">
        <div>
          <b-row>
            <b-col lg="12">
              <h3 align="center">{{ this.User.toUpperCase() }} POLYGON LIST</h3>
              <input class="gap" type="text" v-model="filterText2" placeholder="Country..." />
              <input class="gap" type="text" v-model="filterText1" placeholder="Locations..." />
              <!-- <b-form-select class="gap2" type="text" v-model="filterText3" id="statusDropdown">
                <b-form-select-option value="" disabled>Select Flag</b-form-select-option>
                <b-form-select-option value="Saved">Saved</b-form-select-option>
                <b-form-select-option value="Custom/Edited">Custom/Edited</b-form-select-option>
              </b-form-select> -->
              <table>
                <thead>
                  <tr>
                    <th v-for="(col) in activelogs.columns" :key="col.id">
                      {{ col.toUpperCase() }}
                    </th>
                  </tr>
                </thead>          
                <tbody>
                  <tr v-for="(rw, item) in paginatedData" :key="item">
                    <td>{{ rw.location }}</td>
                    <!-- <td>{{ rw.City }}</td> -->
                    <td>{{ rw.country }}</td>
                    <td>{{ rw.date }}</td>
                    <td>{{ rw.time }}</td>
                    <td>{{ rw.flag }}</td>
                    <td>
                      <b-button v-if="rw.action ==''" class="gap3" variant="primary" :to="{name:'viewpolygon',params:{location:rw.location,city:rw.city,country:rw.country,state:rw.state,datetime:rw.datetime,info:rw.user}}">View Polygon</b-button>
                      <p v-if="rw.action =='null'">{{ rw.action }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div>
                <b-button variant="primary" @click="previousPage" :disabled="currentPage === 1" class="mx-2 py-1">Previous</b-button>
                <span>{{ currentPage }} / {{ totalPages }}</span>
                <b-button variant="primary" @click="nextPage" :disabled="currentPage === totalPages"  class="mx-2 py-1">Next</b-button>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </template>
  <script>
  import axios from '@axios'
  import { BRow, BCol, BButton, BFormSelect, BFormSelectOption, BPopover, BIcon}from "bootstrap-vue"
  export default {
    components: {
      BRow,
      BCol,BButton,
    //   BFormSelect,
    //   BFormSelectOption,
    //   BPopover, BIcon
    },
    data() {
      return {
        loading: true,
        activelogs:null,
        deleteresponse:null,
        User:'',
        filterText1: '',
        filterText2: '',// Filter text\
        // filterText3: '',
        currentPage: 1,
        itemsPerPage: 10, // Number of items per page
      }
    },
    methods:{
      previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    handleModalClose(){
      window.location.reload();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    CustomPolygon: function(){
        axios.post('fetchcustompolygon',{
            user:this.$route.params.user,
            id:this.$route.params.id,
        },{
            // headers: { 'Access-Control-Allow-Origin': '*' }
        }).then(response => {
            this.activelogs = response.data.logs
            this.User=response.data.user
            this.loading = false;
        }).catch(error => {
            // console.log("Something went wrong in countryGetList()")
        })
    },
    DeleteCustomPolygon(row, index){
        axios.post('deletecustompolygon', {
            city:row.Location,
            country:row.Country,
            time:row.Time,
            date:row.Date,
        },{
            // headers: { 'Access-Control-Allow-Origin': '*' }
        }).then(response => {
          this.deleteresponse=response.data
          this.$swal({
              icon: 'success',
              title: 'Data Deleted successfully',
              text: this.response,
          });
          this.CustomPolygon()
        }).catch(error => {
            // console.log("Something went wrong in countryGetList()")
        }) 
    },
    },
    mounted() {
      // this.Error()
        this.CustomPolygon()
        this.clientid=this.$route.params.id
    },
    computed: {
    filteredData() {
      if (this.filterText1 && this.filterText2) {
        const filterTextLower1 = this.filterText1.toLowerCase();
        const filterTextLower2 = this.filterText2.toLowerCase();
        // const filterTextLower3 = this.filterText3.toLowerCase();
        return this.activelogs.data.filter(item =>
          item.location.toLowerCase().includes(filterTextLower1) &&  
          item.country.toLowerCase().includes(filterTextLower2) 
          // && item.Flag.toLowerCase().includes(filterTextLower3)
        );
      } else if (this.filterText1) {
        const filterTextLower1 = this.filterText1.toLowerCase();
        return this.activelogs.data.filter(item =>
          item.location.toLowerCase().includes(filterTextLower1)
        );
      } else if (this.filterText2) {
        const filterTextLower2 = this.filterText2.toLowerCase();
        return this.activelogs.data.filter(item =>
          item.country.toLowerCase().includes(filterTextLower2)
        );
      }
      // } else if (this.filterText3) {
      //   const filterTextLower3 = this.filterText3.toLowerCase();
      //   return this.activelogs.data.filter(item =>
      //     item.flag.toLowerCase().includes(filterTextLower3)
      //   );
      // } 
      else {
        return this.activelogs.data;
      }
    },
    totalPages() {
      return Math.ceil(this.filteredData.length / this.itemsPerPage);
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredData.slice(startIndex, endIndex);
    },
    getColumnClass(index) {
      // Add a specific class to the second column
      return index === 3 ? "modified-column" : "";
    },
    getColumnContent(col, index) {
      // Modify the content of the second column
      if (index === 3) {
        return `<i class="fas fa-user"></i> ${col}`;
      } else {
        return col;
      }
    },
  },
  }
  </script>
  <style>
  .loader {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 75px;
    height: 75px;
    animation: spin 1s linear infinite;
    margin: 20px auto;
    margin-top: 200px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .gap{
  margin-right: 5px;
  border-color:black;
  width: 250px;
  }
  .gap2{
  margin-top: 10px;
  border-color:black;
  width:15%;
  background:white;
  }
  .gap3{
  margin-left: 5px;
  margin-top: 5px;
  }
  .gap4{
  margin-left:20px;
  width: 100px;
  height: 48px;
  }
  .gap5{
  margin-left:20px;
  width: 120px;
  height: 48px;
  }
  .info{
    padding-left:20px;
  }
  .width{
    width: 100px;
  }
  </style>
  <script setup>
  const userType = localStorage.getItem('userType');
  </script>
  